import i18n from "config/i18next";

i18n.addResources("es", "faq", {
  title: "Preguntas frecuentes",
  help: "¿En qué podemos ayudarte?",
  doubts: "Si te quedaron dudas,\n te dejamos a mano las preguntas frecuentes",
  channels1: "También podés comunicarte con nosotros vía mail al",
  operate: "Cómo operar",
  questions: [
    {
      question: "¿Dónde opera pickers?",
      answer: "pickers opera en Argentina, México y Chile.",
    },
    {
      question: "¿Cuáles son los días y horarios de conexión?",
      answer:
        "Nuestra operación funciona de lunes a viernes (días hábiles) de 10 a 18 hs.",
    },
    {
      question: "¿Qué necesito para ser un picker?",
      answer: `Para ser picker necesitás:\n
      *list*
      Los paquetes que vas a transportar son pequeños (no son comidas), por eso podrás retirar más de uno en los puntos de retiro. Además, no necesitás dinero porque ya están pagos.\n      
      <b>Documentación:</b>\n
      *extralist*`,
      answers: [
        `Ser mayor de edad.`,
        `Celular con sistema operativo Android.`,
        `Vehículo (moto, bicicleta, auto o camioneta) y la documentación correspondiente (cédula del vehículo, licencia de conducir y póliza de seguro).`,
        `Mochila / caja para transportar los paquetes.`,
        `Cuenta bancaria a tu nombre (no billetera virtual).`,
      ],
      extraAnswers: [
        `DNI.`,
        `Monotributo (cualquiera de sus categorías o responsable inscripto).`,
        `Número de CUIT.`,
        `Constancia de cuenta bancaria, la cual deberás solicitar en tu banco, con los siguientes datos: N.º de cuenta, CUIT y nombre del titular.`,
      ],
    },
    {
      question: "¿Cuándo puedo empezar a operar?",
      answer: `Podrás registrarte en la aplicación y, en caso de que no cuentes con toda la documentación, operar una semana con nosotros. Es importante que la completes para que podamos gestionar tus pagos.
      \nEn caso de que la zona que querés operar esté con capacidad máxima de repartidores, tu cuenta estará en lista de espera.`,
    },
    {
      question: "¿Para qué se utilizan los turnos?",
      answer: `Con los turnos podrás elegir qué zonas, días y horarios vas a estar disponible para operar con nosotros. Para conocerlos ingresá en la sección <b>Turnos</b> dentro de la aplicación.`,
    },
    {
      question: "¿Cuándo se habilitan los turnos?",
      answer: `<b>Los turnos se habilitan los jueves a partir de las 18:00 hs,</b> podrás reservar los de toda la semana dentro de la aplicación en la sección <b>Turnos.</b> Revisá todos los días la sección, ya que pueden liberarse algunos durante el día.`,
    },
    {
      question: "¿Cuáles son mis zonas?",
      answer:
        "Las zonas disponibles corresponden a las que elegiste en el momento del registro. Podrás tomar un turno dentro de esas opciones. Recordá que cuando comience un turno tendrás que estar en el área para poder operar.",
    },
    {
      question: "¿Cómo tomo un turno?",
      answer: `Una vez dentro de la aplicación:\n
      *123*
      ¡Listo! Para verlos ingresá en <b>Reservados</b> dentro de <b>Turnos.</b>`,
      numberedAnswers: [
        `<b>Ingresá</b> en la sección de <b>Turnos.</b>`,
        `Elegí las @@zones@@, días y horarios para operar. Recordá que las zonas son las que seleccionaste al momento de tu registro.`,
        `Hacé clic en Reservar.`,
      ],
      links: [
        {
          name: "@@zones@@",
          label: "zonas",
          href: "https://linktr.ee/zonadecoberturapickers",
        },
      ],
    },
    {
      question: "¿Qué es un viaje?",
      answer: `Un viaje es un conjunto de paquetes que comparten el mismo punto de origen y región, esto te permite ahorrar tiempo en tus entregas.

      La cantidad de paquetes dentro de un viaje puede variar entre 15 o más.`,
    },
    {
      question: "¿Qué datos necesito para hacer la factura?",
      answer: `Los datos que necesitás son:\n
      *list*`,
      answers: [
        `<b>Fecha de la factura:</b> El día que generás la factura.`,
        `<b>Razón Social:</b> PICKIT ARGENTINA S.A.`,
        `<b>CUIT:</b> 30-71516262-4.`,
        `<b>Condición frente al IVA:</b> Responsable inscripto.`,
        `<b>Actividad principal:</b> Servicios de gestión y logística para el transporte de mercaderías.`,
        `<b>Domicilio fiscal:</b> Juramento 1775, piso 10.`,
        `<b>Código postal:</b> 1428 - CABA.`,
      ],
    },
  ],
});

i18n.addResources("es_AR", "Account", {
  title: "Cuenta",
  questions: [
    {
      question: "¿Dónde opera pickers?",
      answer: "pickers opera en Argentina, México y Chile.",
    },
    {
      question: "¿Cuáles son los días y horarios de conexión?",
      answer:
        "Nuestra operación funciona de lunes a viernes (días hábiles) de 10 a 18 hs.",
    },
    {
      question: "¿Qué necesito para ser un picker?",
      answer: `Para ser picker necesitás:\n
      *list*
      Los paquetes que vas a transportar son pequeños (no son comidas), por eso podrás retirar más de uno en los puntos de retiro. Además, no necesitás dinero porque ya están pagos.\n      
      <b>Documentación:</b>\n
      *extralist*`,
      answers: [
        `Ser mayor de edad.`,
        `Celular con sistema operativo Android.`,
        `Vehículo (moto, bicicleta, auto o camioneta) y la documentación correspondiente (cédula del vehículo, licencia de conducir y póliza de seguro).`,
        `Mochila / caja para transportar los paquetes.`,
        "Cuenta bancaria a tu nombre (no billetera virtual).",
      ],
      extraAnswers: [
        `DNI.`,
        `Monotributo (cualquiera de sus categorías o responsable inscripto).`,
        `Número de CUIT.`,
        `Constancia de cuenta bancaria, la cual deberás solicitar en tu banco, con los siguientes datos: N.º de cuenta, CUIT y nombre del titular.`,
      ],
    },
    {
      question: "¿Qué es y para qué sirve el monotributo?",
      answer: `Es un trámite gratuito y virtual que se realiza desde la @@afip@@, sirve para generar facturas y recibir tus pagos.`,
      links: [
        {
          name: "@@afip@@",
          label: "página de ARCA (ex AFIP)",
          href: "https://arca.gob.ar/monotributo/ayuda/que-es.asp",
        },
        {
          name: "@@email@@",
          label: "ayuda@pickers.tech",
          href: "mailto:ayuda@pickers.tech",
        },
      ],
    },

    {
      question: "¿Cuándo puedo empezar a operar?",
      answer: `Podrás registrarte en la aplicación y, en caso de que no cuentes con toda la documentación, operar una semana con nosotros. Es importante que la completes para que podamos gestionar tus pagos.
      \nEn caso de que la zona que querés operar esté con capacidad máxima de repartidores, tu cuenta estará en lista de espera.`,
    },
    {
      question: "¿Cómo actualizo mis datos personales? ",
      answer: `Ingresá a este @@form@@ para actualizar tus datos o los del vehículo. Los tiempos de gestión son:\n
      <b>3 días hábiles:</b>
      *list*
      <b>7 días hábiles:</b>
      *extralist*
      En caso de que los cambios que solicitaste no se realicen en el tiempo pactado, comunicate con @@email@@ para iniciar un reclamo. `,
      answers: [`Nombre y apellido.`, `Número de teléfono. `, `CBU.`],
      extraAnswers: [
        `Documento de identidad.`,
        `CUIT.`,
        `Monotributo.`,
        `Email.`,
      ],
      links: [
        {
          name: "@@form@@",
          label: "formulario",
          href: "https://docs.google.com/forms/d/e/1FAIpQLSd0R4cqpHY3xjmZqUdKt3-5v5pj5p9Aq3hh7wq30thWN49TCA/viewform",
        },
        {
          name: "@@email@@",
          label: "ayuda@pickers.tech",
          href: "mailto:ayuda@pickers.tech",
        },
      ],
    },
    {
      question: "¿Qué pasa si no me presento a un turno?",
      answer: `En caso de que no te presentes a un turno, y no lo hayas cancelado con anterioridad, se cancelarán todos los turnos de la semana y podrán ser tomados por otros pickers.

        <b>Si las ausencias se repiten, tu cuenta será inhabilitada y no podrás operar hasta que nos comuniquemos con vos.</b>
        `,
    },
    {
      question: "¿Por qué inhabilitaron mi cuenta?",
      answer: `Las inhabilitaciones se realizan cuando no cumplís con @@conditions@@, otros motivos pueden ser:\n
      *list*`,
      answers: [
        `Faltas reiteradas a los turnos reservados.`,
        `Cancelaciones de turnos con menos de 24 horas de anticipación.`,
        `Mala evidencia de entrega o poco tiempo de espera por comprador.`,
        `No lograr el 90% de eficiencia en las entregas.`,
        `Mensajes o lenguaje abusivo que agreda o insulte al personal de los puntos, operaciones, soporte y compradores.`,
        `Reiterada pérdida o extravío de paquetes.`,
        `Datos falsos para recibir o entregar paquetes.`,
      ],
      links: [
        {
          name: "@@conditions@@",
          label: "nuestros términos y condiciones",
          href: "https://docs.google.com/document/d/e/2PACX-1vSQLxxpwVNsCWJ2tdBclxZfsmMzYSGH54rqb_BCzcig2bqIDX_BJ6YESQ-4QdJNQFlWsO5qfsFi5J_k/pub",
        },
      ],
    },
    {
      question: "Buenas prácticas para el uso de tu cuenta",
      answer: `Te compartimos algunos consejos para tu operación:\n
      *list*`,
      answers: [
        `No compartas, alquiles, o prestes tu cuenta a terceros.`,
        `No utilices aplicaciones que alteren tu ubicación.`,
        `Realizá los pasos para el retiro, entrega y devolución tal como aparecen en la aplicación.`,
        `Aceptá la responsabilidad del viaje asignado, cumpliendo con los tiempos y acercándote al punto de retiro inmediatamente para evitar inconvenientes.`,
        `Verificá que los puntos registren las devoluciones.`,
      ],
    },
    {
      question: "Actualización de la aplicación",
      answer:
        "En pickers siempre estamos realizando mejoras, por eso te recomendamos que mantengas <b>actualizada la aplicación</b> y revises regularmente si tenés la última versión en la @@playstore@@. ",
      links: [
        {
          name: "@@playstore@@",
          label: "Play Store",
          href: "https://play.google.com/store/apps/details?id=com.pickit.pickers&hl=es_AR",
        },
      ],
    },
    {
      question: "¿Qué hago si tengo un problema durante el recorrido?",
      answer: `Comunicate con nuestro equipo de soporte al @@whatsapp@@.`,
      links: [
        {
          name: "@@whatsapp@@",
          label: "WhatsApp",
          href: "{{whatsAppLink}}",
        },
      ],
    },
  ],
});

i18n.addResources("es_CO", "Account", {
  title: "Cuenta",
  questions: [
    {
      question: "¿Dónde opera pickers?",
      answer: "pickers opera en Argentina, México, Colombia y Chile.",
    },
    {
      question: "¿Cuáles son los días y horarios de conexión?",
      answer:
        "Nuestra operación funciona de lunes a viernes (días hábiles) de 10 a 18 hs.",
    },
    {
      question: "¿Qué necesito para ser un picker?",
      answer: `Para ser picker necesitas:\n
      *list*
      Los paquetes que vas a transportar son pequeños (no son comidas), por eso puedes retirar más de uno en los puntos de colecta. Además, no necesitas dinero porque ya están pagos.\n      
      Documentación:\n
      *extralist*
      \nDeberás tener activo el NIT para poder cobrar.
      \nEn caso de que no completes los datos, podrás operar durante <b>una semana.</b> ¿Necesitas ayuda? Ingresa a @@tutorial@@`,
      answers: [
        `Ser mayor de edad.`,
        `Celular con sistema operativo Android.`,
        `Vehículo (moto, bicicleta, auto o camioneta) y la documentación correspondiente (licencia de conducir, tarjeta de propiedad vehicular y SOAT).`,
        `Mochila / caja para transportar los paquetes.`,
      ],
      extraAnswers: [
        `Cédula de identificación.`,
        `Constancia de cuenta bancaria a tu nombre (N.º de cuenta, nombre del titular, RUT).`,
        `N.º de RUT.`,
      ],
      links: [
        {
          name: "@@tutorial@@",
          label: "este tutorial.",
          href: "https://docs.google.com/presentation/d/e/2PACX-1vQ7It06Crv6V8LQ-qWlfHFNEPPrbkP6MgUJeQABnEy5MuQktFhflSTT8CcIPIXEC5o9DbcMD2pYHGph/pub?start=false&loop=false&delayms=3000",
        },
      ],
    },
    {
      question: "¿Cuándo puedo empezar a operar?",
      answer: `Una vez que <b>completes el registro y validemos tu perfil,</b> recibirás un mail para saber cómo continuar el proceso de capacitación dentro de la app.
      \nEn caso de que la zona que quieras operar esté con capacidad máxima de repartidores, tu cuenta estará en estado pendiente.`,
    },
    {
      question: "¿Cómo actualizo mis datos personales? ",
      answer: `Ingresa a este @@form@@ para actualizar tus datos o los del vehículo, te compartimos los tiempos de gestión para cada cambio:\n
      <b>1 día hábil:</b>
      *list*
      <b>7 días hábiles:</b>
      *extralist*
      En caso de que los cambios que solicitaste no se realicen en el tiempo pactado, comunícate con @@email@@ para iniciar un reclamo. `,
      answers: [
        `Nombre y apellido.`,
        `Número de teléfono. `,
        `Número de cuenta bancaria.`,
      ],
      extraAnswers: [`Documento de identificación.`, `RUT/NIT.`, `Email.`],
      links: [
        {
          name: "@@form@@",
          label: "formulario",
          href: "https://docs.google.com/forms/d/e/1FAIpQLSd0R4cqpHY3xjmZqUdKt3-5v5pj5p9Aq3hh7wq30thWN49TCA/viewform",
        },
        {
          name: "@@email@@",
          label: "ayuda@pickers.tech",
          href: "mailto:ayuda@pickers.tech",
        },
      ],
    },
    {
      question: "¿Cuáles son los términos y condiciones?",
      answer: `Te compartimos nuestros @@terms@@ para que los revises cuando lo necesites.`,
      links: [
        {
          name: "@@terms@@",
          label: "términos y condiciones",
          href: "https://docs.google.com/document/d/e/2PACX-1vQnSaaS_tnRuH2M9_yDyqE-kP9GeW7soZNlqXa_7VNNThMyk0Dh56QPF1SfgvodvTjkn4lriBGvmimE/pub",
        },
      ],
    },
    {
      question: "¿Qué pasa si no me presento a un turno?",
      answer: `En caso de que no te presentes a un turno, y no lo hayas cancelado con anterioridad, se cancelarán todos los turnos de la semana y podrán ser tomados por otros pickers.

        <b>Si los ausentes se repiten, tu cuenta será inhabilitada y no podrás operar hasta que nos comuniquemos contigo.</b>
        `,
    },
    {
      question: "Actualización de la app",
      answer:
        "En pickers siempre estamos realizando mejoras, por eso te recomendamos que mantengas <b>actualizada la app</b> y revises regularmente si tienes la última versión de la @@playstore@@. ",
      links: [
        {
          name: "@@playstore@@",
          label: "Play Store",
          href: "https://play.google.com/store/apps/details?id=com.pickit.pickers&hl=es_AR",
        },
      ],
    },
    {
      question: "Otras consultas",
      answer: `En caso de que tengas problemas con tu vehículo durante el recorrido, comunícate con soporte para saber cómo continuar con tu operación.
        Si tienes viajes asignados, te pedimos que los canceles para evitar inconvenientes.
        Recuerda que puedes comunicarte con nuestro equipo de soporte a través del email: @@email@@`,
      links: [
        {
          name: "@@email@@",
          label: "ayuda@pickers.tech",
          href: "{{mailto:ayuda@pickers.tech}}",
        },
      ],
    },
  ],
});

i18n.addResources("es_MX", "Account", {
  title: "Cuenta",
  questions: [
    {
      question: "¿Dónde opera pickers?",
      answer: "pickers opera en Argentina, México y Chile.",
    },
    {
      question: "¿Cuáles son los días y horarios de conexión?",
      answer:
        "Nuestra operación funciona de lunes a viernes (días hábiles) de 11 a 17 hs.",
    },
    {
      question: "¿Qué necesito para ser un picker?",
      answer: `Para ser picker necesitas:\n
      *list*
      Los paquetes que vas a transportar son pequeños (no son comidas), por eso puedes retirar más de uno en los puntos de retiro. Además, no necesitas dinero porque ya están pagos.\n      
      <b>Documentación:</b>\n
      *extralist*
      <b>Importante:</b> Los únicos regímenes fiscales válidos para operar con nosotros son: \n
      *extraextralist*
      ¿Necesitas ayuda? Ingresa a @@tutorial@@`,
      answers: [
        `Ser mayor de edad.`,
        `Celular con sistema operativo Android.`,
        `Vehículo (moto, bicicleta, auto o camioneta) y la documentación correspondiente (licencia de conducir, tarjeta de circulación y póliza de seguro).`,
        `Mochila / caja para transportar los paquetes.`,
        `Cuenta bancaria a tu nombre (no billetera virtual).`,
      ],
      extraAnswers: [
        `CURP.`,
        `Constancia de cuenta bancaria a tu nombre (N.º de CLABE, nombre del titular, RFC).`,
        `Número de RFC.`,
      ],
      extraExtraAnswers: [
        `Régimen simplificado de confianza (debe tener ISR).`,
        `Régimen de actividades empresariales (no debe tener ISR).`,
      ],
      links: [
        {
          name: "@@tutorial@@",
          label: "este tutorial.",
          href: "https://docs.google.com/presentation/d/e/2PACX-1vSxjtFs-f9UdtSJ7sQP-ymEQE3J8DnVJOqDJ1-GcxGTrzoJaj67QOQa1o60lc4PgAviU_j72C67NLJm/pub?start=false&loop=false&delayms=3000",
        },
      ],
    },
    {
      question: "¿Cuándo puedo empezar a operar?",
      answer: `Puedes registrarte en la aplicación y, en caso de que no cuentes con toda la documentación, operar una semana con nosotros. Es importante que la completes para que podamos gestionar tus pagos.
      \nEn caso de que la zona que quieras operar esté con capacidad máxima de repartidores, tu cuenta estará en lista de espera.`,
    },
    {
      question: "¿Cómo actualizo mis datos personales? ",
      answer: `Ingresa a este @@form@@ para actualizar tus datos o los del vehículo. Los tiempos de gestión son:\n
      <b>3 días hábiles:</b>
      *list*
      <b>7 días hábiles:</b>
      *extralist*
      En caso de que los cambios que solicitaste no se realicen en el tiempo pactado, comunícate con @@email@@ para iniciar un reclamo. `,
      answers: [
        `Nombre y apellido.`,
        `Número de teléfono. `,
        `Número de CLABE.`,
      ],
      extraAnswers: [`CURP.`, `RFC.`, `Email.`],
      links: [
        {
          name: "@@form@@",
          label: "formulario",
          href: "https://docs.google.com/forms/d/e/1FAIpQLSd0R4cqpHY3xjmZqUdKt3-5v5pj5p9Aq3hh7wq30thWN49TCA/viewform",
        },
        {
          name: "@@email@@",
          label: "ayuda@pickers.tech",
          href: "mailto:ayuda@pickers.tech",
        },
      ],
    },
    {
      question: "¿Qué pasa si no me presento a un turno?",
      answer: `En caso de que no te presentes a un turno, y no lo hayas cancelado con anterioridad, se cancelarán todos los turnos de la semana y podrán ser tomados por otros pickers.

        <b>Si las ausencias se repiten, tu cuenta será inhabilitada y no puedes operar hasta que nos comuniquemos contigo.</b>
        `,
    },
    {
      question: "¿Por qué inhabilitaron mi cuenta?",
      answer: `Las inhabilitaciones se realizan cuando no cumples con @@conditions@@, otros motivos pueden ser:\n
      *list*`,
      answers: [
        `Faltas reiteradas a los turnos reservados.`,
        `Cancelaciones de turnos con menos de 24 horas de anticipación.`,
        `Mala evidencia de entrega, poco tiempo de espera por comprador o fake GPS.`,
        `No lograr el 90% de eficiencia en las entregas.`,
        `Mensajes o lenguaje abusivo que agreda o insulte al personal de los puntos, operaciones, soporte y compradores.`,
        `Reiterada pérdida o extravío de paquetes.`,
        `Datos falsos para recibir o entregar paquetes.`,
      ],
      links: [
        {
          name: "@@conditions@@",
          label: "nuestros términos y condiciones",
          href: "https://docs.google.com/document/d/e/2PACX-1vRqrxPDeTxs5ywElM2OJGCWHYbBizaabDCt3lrCjYLlLdT-zBtAbO_6To-ji4NX9f8vrGBWbzL5JRjf/pub",
        },
      ],
    },
    {
      question: "Buenas prácticas para el uso de tu cuenta",
      answer: `Te compartimos algunos consejos para tu operación:\n
      *list*`,
      answers: [
        `No compartas, alquiles, o prestes tu cuenta a terceros.`,
        `No utilices aplicaciones que alteren tu ubicación.`,
        `Realiza los pasos para el retiro, entrega y devolución tal como aparecen en la aplicación.`,
        `Acepta la responsabilidad del viaje asignado, cumpliendo con los tiempos y acercándote al punto de retiro inmediatamente para evitar inconvenientes.`,
        `Verifica que los puntos registren las devoluciones.`,
      ],
    },
    {
      question: "Actualización de la aplicación",
      answer:
        "En pickers siempre estamos realizando mejoras, por eso te recomendamos que mantengas <b>actualizada la aplicación</b> y revises regularmente si tienes la última versión de la @@playstore@@. ",
      links: [
        {
          name: "@@playstore@@",
          label: "Play Store",
          href: "https://play.google.com/store/apps/details?id=com.pickit.pickers&hl=es_AR",
        },
      ],
    },
    {
      question: "¿Qué hago si tengo un problema durante el recorrido?",
      answer: `Comunícate con nuestro equipo de soporte al @@whatsapp@@.`,
      links: [
        {
          name: "@@whatsapp@@",
          label: "WhatsApp",
          href: "{{whatsAppLink}}",
        },
      ],
    },
  ],
});

i18n.addResources("es_AR", "Slots", {
  title: "Turnos",
  questions: [
    {
      question: "¿Para qué se utilizan los turnos?",
      answer: `Con los turnos podrás elegir qué zonas, días y horarios vas a estar disponible para operar con nosotros. Para conocerlos ingresá en la sección <b>Turnos</b> dentro de la aplicación.`,
    },
    {
      question: "¿Cuándo se habilitan los turnos?",
      answer: `<b>Los turnos se habilitan los jueves a partir de las 18:00 hs,</b> podrás reservar los de toda la semana dentro de la aplicación en la sección <b>Turnos.</b> Revisá todos los días la sección, ya que pueden liberarse algunos durante el día.`,
    },
    {
      question: "¿Cómo tomo un turno?",
      answer: `Una vez dentro de la aplicación:\n
      *123*
      ¡Listo! Para verlos ingresá en <b>Reservados</b> dentro de <b>Turnos.</b>`,
      numberedAnswers: [
        `<b>Ingresá</b> en la sección de <b>Turnos.</b>`,
        `Elegí las @@zones@@, días y horarios para operar. Recordá que las zonas son las que seleccionaste al momento de tu registro.`,
        `Hacé clic en Reservar.`,
      ],
      links: [
        {
          name: "@@zones@@",
          label: "zonas",
          href: "https://linktr.ee/zonadecoberturapickers",
        },
      ],
    },
    {
      question: "¿Cuáles son mis zonas?",
      answer:
        "Las zonas disponibles corresponden a las que elegiste en el momento del registro. Podrás tomar un turno dentro de esas opciones. Recordá que cuando comience un turno tendrás que estar en el área para poder operar.",
    },
    {
      question: " ¿Qué hago si quiero tomar más zonas?",
      answer: `Comunicate con nuestro equipo de soporte al @@whatsapp@@.\n
        <b>Recordá que no podés tomar turnos en más de una zona en simultáneo.</b>`,
      links: [
        {
          name: "@@whatsapp@@",
          label: "WhatsApp",
          href: "{{whatsAppLink}}",
        },
      ],
    },
    {
      question: "¿Cómo iniciar un turno (check-in)? ",
      answer: `Una vez dentro de la aplicación:\n
      *123*
      ¡Listo! Ya podés iniciar un viaje.`,
      numberedAnswers: [
        `<b>Dirigite a tu</b> @@zone@@. Una vez allí, ingresá a la sección de <b>Turnos.</b>`,
        `Hacé clic en <b>Reservados.</b>`,
        `Seleccioná <b>Iniciar turno</b> (podrás ver el botón cuando el turno esté cercano al horario de inicio).`,
      ],
      links: [
        {
          name: "@@zone@@",
          label: "zona de reparto",
          href: "{{zonesLink}}",
        },
      ],
    },
    {
      question: "¿Cuánto tiempo tengo para hacer el check-in?",
      answer: `Podrás iniciar tu turno desde 10 minutos antes hasta 15 minutos después. \n
      En caso de que <b>no se realice el check-in perderás todos los turnos reservados en la semana.</b>`,
    },
    {
      question: "¿Puedo asignarme un turno que ya comenzó?",
      answer: `En caso de que <b>el turno tenga capacidad disponible</b> podrás asignártelo sin necesidad de hacer el check-in.`,
    },
    {
      question: "¿Cómo cancelo un turno?",
      answer: `Una vez dentro de la aplicación:\n
      *123*
      ¡Listo! Ya cancelaste el turno.`,
      numberedAnswers: [
        `<b>Ingresá</b> a Reservados dentro de la sección de <b>Turnos.</b>`,
        `Seleccioná el turno que querés cancelar.`,
        `Hacé clic en el tacho.`,
      ],
    },
  ],
});

i18n.addResources("es_MX", "Slots", {
  title: "Turnos",
  questions: [
    {
      question: "¿Para qué se utilizan los turnos?",
      answer: `Con los turnos puedes elegir qué zonas, días y horarios vas a estar disponible para operar con nosotros. Para conocerlos ingresa en la sección <b>Turnos</b> dentro de la aplicación.`,
    },
    {
      question: "¿Cuándo se habilitan los turnos?",
      answer: `<b>Los turnos se habilitan los jueves a partir de las 18:00 hs,</b> puedes reservar los de toda la semana dentro de la aplicación en la sección <b>Turnos.</b> Revisa todos los días la sección, ya que pueden liberarse algunos durante el día.`,
    },
    {
      question: "¿Cómo tomo un turno?",
      answer: `Una vez dentro de la aplicación:\n
      *123*
      ¡Listo! Para verlos ingresa en <b>Reservados</b> dentro de <b>Turnos.</b>`,
      numberedAnswers: [
        `Ingresa en la sección de <b>Turnos.</b>`,
        `Elige las @@zones@@, días y horarios para operar. Recuerda que las <b>zonas</b> son las que seleccionaste al momento de tu registro.`,
        `Haz clic en Reservar.`,
      ],
      links: [
        {
          name: "@@zones@@",
          label: "zonas",
          href: "https://linktr.ee/zonadecoberturamexico",
        },
      ],
    },
    {
      question: "¿Cuáles son mis zonas?",
      answer:
        "Las zonas disponibles corresponden a las que elegiste en el momento del registro. Puedes tomar un turno dentro de esas opciones. Recuerda que cuando comience un turno tendrás que estar en el área para poder operar.",
    },

    {
      question: "¿Qué hago si quiero tomar más zonas?",
      answer: `Comunícate con nuestro equipo de soporte al @@whatsapp@@.\n
      <b>Recuerda que no puedes tomar turnos en más de una zona en simultáneo.</b>`,
      links: [
        {
          name: "@@whatsapp@@",
          label: "WhatsApp",
          href: "{{whatsAppLink}}",
        },
      ],
    },
    {
      question: "¿Cómo iniciar un turno (check-in)? ",
      answer: `Una vez dentro de la aplicación:\n
      *123*
      ¡Listo! Ya puedes iniciar un viaje.`,
      numberedAnswers: [
        `<b>Dirígete a tu</b> @@zone@@. Una vez allí, ingresa a la sección de <b>Turnos.</b>`,
        `Haz clic en <b>Reservados.</b>`,
        `Selecciona <b>Iniciar turno</b> (puedes ver el botón cuando el turno esté cercano al horario de inicio).`,
      ],
      links: [
        {
          name: "@@zone@@",
          label: "zona de reparto",
          href: "{{zonesLink}}",
        },
      ],
    },
    {
      question: "¿Cuánto tiempo tengo para hacer el check-in?",
      answer: `Puedes iniciar tu turno desde 10 minutos antes hasta 15 minutos después.\n
      En caso de que <b>no se realice el check-in perderás todos los turnos reservados en la semana.</b>`,
    },
    {
      question: "¿Puedo asignarme un turno que ya comenzó?",
      answer: `En caso de que <b>el turno tenga capacidad disponible</b> puedes asignártelo sin necesidad de hacer el check-in.`,
    },
    {
      question: "¿Cómo cancelo un turno?",
      answer: `Una vez dentro de la aplicación:\n
      *123*
      ¡Listo! Ya cancelaste el turno.`,
      numberedAnswers: [
        `Ingresa a <b>Reservados</b> dentro de la sección de <b>Turnos.</b>`,
        `Selecciona el turno que quieres cancelar.`,
        `Haz clic en el cesto.`,
      ],
    },
  ],
});

i18n.addResources("es_CO", "Slots", {
  title: "Turnos",
  questions: [
    {
      question: "¿Para qué se utilizan los turnos?",
      answer: `Con los turnos puedes elegir qué zonas, días y horarios vas a estar disponible para operar con nosotros. 
      \nPara conocerlos ingresa en la sección Turnos dentro de la app.`,
    },
    {
      question: "¿Cuándo se habilitan los turnos?",
      answer: `Los turnos se habilitan <b>los jueves a partir de las 18:00hs.</b> Para más información, ingresa en la sección Turnos dentro de la app.
      \nRevisa todos los días (lunes a viernes) la sección de Turnos, ya que pueden liberarse algunos durante el día.`,
    },

    {
      question: "¿Cuáles son mis zonas?",
      answer:
        "Al momento de armar un turno puedes ver las @@zones@@ que tenemos disponibles para operar y elegir la más cercana a tu ubicación.",
      links: [
        {
          name: "@@zones@@",
          label: "zonas",
          href: "https://linktr.ee/zonadecoberturacolombia",
        },
      ],
    },
    {
      question: "¿Cómo tomo un turno?",
      answer: `Una vez dentro de la app:\n
      *123*
      ¡Listo! Ya reservaste tus turnos.`,
      numberedAnswers: [
        `<b>Ingresa en la sección</b> de Turnos.`,
        `<b>Elige las zonas,</b> días y horarios para operar.`,
        `Haz clic en <b>Reservar.</b>`,
      ],
    },
    {
      question: "¿Cómo iniciar un turno (check-in)? ",
      answer: `Una vez dentro de la app:\n
      *123*
      ¡Listo! Ya hiciste tu check-in.`,
      numberedAnswers: [
        `Cuando <b>llegues a tu @@zone@@ ingresa</b> a la sección de Turnos.`,
        `Haz clic en <b>Reservados.</b>`,
        `Selecciona <b>Iniciar turno</b> (puedes ver el botón cuando el turno esté por iniciar).`,
      ],
      links: [
        {
          name: "@@zone@@",
          label: "zona de reparto",
          href: "{{zonesLink}}",
        },
      ],
    },
    {
      question: "¿Cuánto tiempo tengo para hacer el check-in?",
      answer: `Si <b>el turno no comenzó,</b> tienes <b>10 minutos</b> para hacerlo.
      Si <b>el turno está en proceso, tienes 15 minutos</b> para hacerlo y tu perfil será etiquetado como tarde, esto afectará el cobro del asegurado (premio).
      \nEn caso de que <b>no se realice el check-in, tu perfil será etiquetado como ausente y perderás todos los turnos reservados en la semana.</b>
      \nPara conocer los detalles de los premios, visita la sección Mis ganancias.`,
    },
    {
      question: "¿Puedo asignarme un turno que ya comenzó?",
      answer: `En caso de que <b>el turno tenga capacidad disponible</b> puedes asignártelo sin necesidad de hacer el check-in.`,
    },
    {
      question: "¿Cómo cancelo un turno?",
      answer: `Una vez dentro de la app:\n
      *123*
      ¡Listo! Ya cancelaste el turno.`,
      numberedAnswers: [
        `<b>Ingresa</b> en la sección Reservados.`,
        `<b>Selecciona</b> el turno que quieres cancelar.`,
        `Haz clic en <b>el cesto.</b>`,
      ],
    },
  ],
});

i18n.addResources("es_AR", "Trips", {
  title: "Viajes",
  questions: [
    {
      question: "¿Qué es un viaje?",
      answer: `Un viaje es un conjunto de paquetes que comparten el mismo punto de origen y región, esto te permite ahorrar tiempo en tus entregas. \n
      La cantidad de paquetes dentro de un viaje puede variar entre 15 o más.`,
    },
    {
      question: "¿Qué es un viaje PRO?",
      answer: `<b>Es un viaje con mayor ganancia</b> donde entregás varios paquetes iguales en un mismo destino. Por ejemplo: si un cliente compró 5 productos iguales, verás la etiqueta <b>PRO</b> en tu listado (recordá que el listado mostrará la cantidad de paradas pendientes en tu viaje).\n
      Para completarlo:
      *list*
      Al finalizar la semana recibirás en tu balance semanal un extra por cada paquete PRO. \n
      Tip: Cada parada tiene un máximo de 10 paquetes.`,
      answers: [
        `Escaneá cada uno de los paquetes por separado.`,
        `Solo cargarás los datos de quien recibe una vez.`,
      ],
    },
    {
      question: "¿Cómo me asigno un viaje?",
      answer: `Una vez que iniciaste tu turno: \n
      *123*`,
      numberedAnswers: [
        `Ingresá en el menú.`,
        `Hacé clic en <b>Viajes.</b>`,
        `Iniciá un viaje y comenzá a operar.`,
      ],
    },
  ],
});

i18n.addResources("es", "Trips", {
  title: "Viajes",
  questions: [
    {
      question: "¿Qué es un viaje?",
      answer: `Un viaje es un conjunto de paquetes que comparten el mismo punto de origen y región, esto te permite ahorrar tiempo en tus entregas.\n
      La cantidad de paquetes dentro de un viaje puede variar entre 15 o más.`,
    },
    {
      question: "¿Qué es un viaje PRO?",
      answer: `<b>Es un viaje con mayor ganancia</b> donde entregas varios paquetes iguales en un mismo destino. Por ejemplo: si un cliente compró 5 productos iguales, verás la etiqueta <b>PRO</b> en tu listado (recuerda que el listado mostrará la cantidad de paradas pendientes en tu viaje).\n
      Para completarlo:
      *list*
      Al finalizar la semana recibirás en tu balance semanal un extra por cada paquete PRO. \n
      Tip: Cada parada tiene un máximo de 10 paquetes.`,
      answers: [
        `Escanea cada uno de los paquetes por separado.`,
        `Solo cargarás los datos de quien recibe una vez.`,
      ],
    },
    {
      question: "¿Cómo me asigno un viaje?",
      answer: `Una vez que iniciaste tu turno: \n
      *123*`,
      numberedAnswers: [
        `<b>Ingresa</b> en el menú.`,
        `Haz clic en <b>Viajes.</b>`,
        `Inicia un viaje y comienza a operar.`,
      ],
    },
  ],
});

i18n.addResources("es_CO", "Trips", {
  title: "Viajes",
  questions: [
    {
      question: "¿Qué es un viaje?",
      answer: `Un viaje es un conjunto de paquetes que comparten el mismo punto de origen, región y zonas de reparto.\n
      La cantidad de paquetes dentro de un viaje pueden variar entre 15 o más.\n
      Esta forma de operar te permite ahorrar tiempo en tus entregas y retirar más paquetes de un mismo punto para comenzar a repartir.`,
    },
    {
      question: "¿Qué es un viaje PRO?",
      answer: `<b>Es un viaje con mayor ganancia</b> donde entregas varios paquetes iguales en un mismo destino. Por ejemplo: si un cliente compró 5 productos iguales, verás la etiqueta <b>PRO</b> en tu listado (recuerda que el listado mostrará la cantidad de paradas pendientes en tu viaje).\n
      Para completarlo:
      *list*
      Al finalizar la semana recibirás en tu balance semanal un extra por cada paquete PRO. \n
      Tip: Cada parada tiene un máximo de 10 paquetes.`,
      answers: [
        `Escanea cada uno de los paquetes por separado.`,
        `Solo cargarás los datos de quien recibe una vez.`,
      ],
    },
    {
      question: "¿Cómo me asigno un viaje?",
      answer: `Una vez dentro de la app, reserva un turno y realiza el proceso de check-in, para continuar: \n
      *123*
      ¡Listo! Ya puedes comenzar a operar.`,
      numberedAnswers: [
        `<b>Ingresa</b> en el menú.`,
        `Haz clic en <b>Viajes.</b>`,
        `<b>Inicia un viaje</b> y comienza a operar.`,
      ],
    },
  ],
});

i18n.addResources("es_AR", "PickUp", {
  title: "Retiro",
  questions: [
    {
      question: "¿Dónde retiro los paquetes?",
      answer: `De los locales que forman parte de nuestra red y se los conoce como puntos pickit.  
      
      Conocé cuáles están en tu zona: @@country@@.`,
      links: [
        {
          name: "@@country@@",
          label: "{{country}}",
          href: "{{zonesLink}}",
        },
      ],
    },
    {
      question: "Llegué al punto, ¿qué hago?",
      answer: `*123*`,
      numberedAnswers: [
        `Hacé clic en <b>Llegué al punto.</b>`,
        `Presentá el <b>código de barras desde la aplicación.</b> En caso de que el punto no tenga lector, informale el número de retiro que encontrás debajo del código (PKR-).
        Podrás ver el número de cada paquete, haciendo clic en la lupa que está debajo del código de barras.`,
        `Escaneá <b>todos los paquetes</b> que te entrega el punto, en caso de que tengas inconveniente con alguno, podrás ingresarlo manualmente.`,
      ],
    },
    {
      question: "No puedo retirar uno o varios paquetes, ¿qué hago?",
      answer: `En caso de que los paquetes no se encuentren en condiciones, el punto esté cerrado o con algún problema, en la aplicación hacé clic en <b>No puedo retirarlos</b> e indicá el motivo general.\n 
      Si tenés problemas con un paquete, utilizá la opción del tacho para eliminarlo del viaje. \n
      En caso de no encontrar el motivo dentro de la aplicación, hacé clic en <b>Ir a soporte.</b>`,
    },
    {
      question: "Ya tengo los paquetes, ¿qué hago?",
      answer: `<b>Una vez que retires los paquetes,</b> podés tener dos tipos: \n
      *list*
      En caso de que no puedas retirarlos, hacé clic en el tacho para eliminarlo de la lista.`,
      answers: [
        `<b>Paquetes con código de barras:</b> hay que escanearlos, y si no podés hacerlo, ingresalo manualmente.`,
        `<b>Paquetes sin código de barras:</b> solo confirmar que los tenés, no hay que escanearlos.`,
      ],
    },
    {
      question: "¿Qué hago si se cancela un viaje?",
      answer: `En caso de que se cancele un viaje te avisaremos a través de la aplicación y podrás asignarte otro.`,
    },
  ],
});

i18n.addResources("es", "PickUp", {
  title: "Retiro",
  questions: [
    {
      question: "¿De dónde retiro los paquetes?",
      answer: `De los locales que forman parte de nuestra red y se los conoce como puntos pickit. 
      
      Conoce cuáles están en tu zona: @@country@@.`,
      links: [
        {
          name: "@@country@@",
          label: "{{country}}",
          href: "{{zonesLink}}",
        },
      ],
    },
    {
      question: "Llegué al punto, ¿qué hago?",
      answer: `*123*`,
      numberedAnswers: [
        `Haz clic en <b>Llegué al punto.</b>`,
        `Presenta el <b>código de barras desde la aplicación.</b> En caso de que el punto no tenga lector, infórmale el número de retiro que encontrás debajo del código (PKR-). 
        Puedes ver el número de cada paquete, haciendo clic en la lupa que está debajo del código de barras.`,
        `Escanea <b>todos los paquetes</b> que te entrega el punto, en caso de que tengas inconveniente con alguno, puedes ingresarlo manualmente.`,
      ],
    },
    {
      question: "No puedo retirar el paquete  o varios paquetes, ¿qué hago?",
      answer: `En caso de que los paquetes no se encuentren en condiciones, el punto esté cerrado o con algún problema, en la aplicación haz clic en <b>No puedo retirarlos</b> e indica el motivo general.\n
      Si tienes problemas con un paquete, utiliza la opción del cesto para eliminarlo del viaje.\n
      En caso de no encontrar el motivo dentro de la aplicación, haz clic en <b>Ir a soporte.</b>`,
    },
    {
      question: "Ya tengo los paquetes, ¿qué hago?",
      answer: `<b>Una vez que retires los paquetes,</b> puedes tener dos tipos:  

      <b>Paquetes con código de barras:</b> hay que escanearlos, y si no puedes hacerlo, ingrésalo manualmente. 
      
      <b>Paquetes sin código de barras:</b> solo confirmar que los tienes, no hay que escanearlos.
            
      En caso de que no puedas retirarlos, haz clic en el cesto para eliminarlo de la lista.`,
    },
    {
      question: "¿Qué hago si se cancela un viaje?",
      answer: `En caso de que se cancele un viaje te avisaremos a través de la aplicación y puedes asignarte otro.`,
    },
  ],
});

i18n.addResources("es_CO", "PickUp", {
  title: "Retiro",
  questions: [
    {
      question: "¿De dónde retiro los paquetes?",
      answer: `De los locales que forman parte de la red de pickit y se los conoce como puntos pickit. 
      
      Conoce cuáles están en tu zona: @@country@@`,
      links: [
        {
          name: "@@country@@",
          label: "{{country}}",
          href: "{{zonesLink}}",
        },
      ],
    },
    {
      question: "Llegué al punto, ¿qué hago?",
      answer: `*123*`,
      numberedAnswers: [
        `Haz clic en <b>Llegué al punto.</b>`,
        `Presenta el <b>código de barras</b> desde la app. En caso de que el punto no tenga lector, infórmale el número de retiro que se encuentra debajo del código. 
        Puedes ver el número de cada paquete, haciendo clic en la lupa que está debajo del código de barras.`,
        `Escanea <b>todos los paquetes,</b> en caso de que no puedas ingresar alguno de esta forma podrás hacerlo manualmente.`,
      ],
    },
    {
      question: "No puedo retirar el paquete, ¿qué hago?",
      answer: `En caso de que el punto tenga algún problema o se encuentre cerrado y no puedas retirar el paquete, haz clic en <b>No puedo retirarlos</b> e indica el motivo que corresponda a todos los paquetes del viaje.\n
      Si utilizas la opción del cesto, se le aplicará a ese paquete el motivo imposible de colecta.\n
      En caso de no encontrar el motivo dentro de la app, haz clic en <b>Ir a soporte.</b>\n
      Revisa que el paquete se encuentre en buenas condiciones para poder retirarlo del punto.`,
    },
    {
      question: "Ya tengo los paquetes, ¿qué hago?",
      answer: `<b>Una vez que retires los paquetes,</b> ten en cuenta que puedes tener dos tipos:  

      <b>Paquetes con código de barras:</b> hay que escanearlos, y si no puedes hacerlo, ingrésalo manualmente. 
      
      <b>Paquetes sin código de barras:</b> no hay que escanearlos, solo avisar de que los tienes en tus manos.
            
      En caso de que no puedas retirarlos, haz clic en el cesto para eliminarlo de la lista, indicando el motivo imposible de colecta y devuélvelos al punto.`,
    },
    {
      question: "¿Qué hago si se cancela un viaje?",
      answer: `En caso de que se cancele un viaje te avisaremos a través de la app y puedes asignarte otro.`,
    },
    {
      question: "¿Cómo cancelo un paquete dentro del viaje?",
      answer: `<b>Una vez que te asignes un viaje,</b> puedes ver los paquetes. En caso de que no puedas retirar alguno:  
      \n*123*
      \nRecuerda que ante reiteradas cancelaciones con motivos inválidos, tu cuenta puede ser inhabilitada.
      \n<b>En caso de que el motivo no esté dentro de los que ves en pantalla, haz clic en Ir a soporte.</b>
      \n¡Listo! Ya cancelaste un paquete.`,
      numberedAnswers: [
        `Ingresa al <b>paquete.</b>`,
        `Haz clic en <b>el cesto.</b>`,
        `<b>Selecciona el motivo</b> por el que no puedes retirarlo.`,
      ],
    },
  ],
});

i18n.addResources("es_AR", "Deliver", {
  title: "Entrega",
  questions: [
    {
      question: "¿Cómo entrego un paquete?",
      answer: `Al salir del punto, verás el listado de destinos para llevar los paquetes. Los mismos están ordenados por cercanía.\n
      *123*
      ¡Listo! Ya podés continuar con tu viaje.`,
      numberedAnswers: [
        `Seleccioná el destino por el que quieras comenzar tu recorrido. Recordá que el primero de la lista es el recomendado.`,
        `Una vez que te encuentres en el destino, hacé clic en <b>Llegué al domicilio,</b> podrás llamar a la persona en caso que lo necesites.`,
        `Hacé clic en <b>Validar entrega.</b> Completá los datos de quién recibe y la forma de validar que te indique la aplicación, puede ser foto, firma y/o escaneo del paquete.`,
        `Hace clic en <b>Entregar paquete.</b>`,
      ],
    },
    {
      question: "¿Cómo valido el documento de quien recibe?",
      answer: `La validación es automática, el sistema lo realiza con el documento que cargás en la aplicación. Recordá que el ingreso de datos falsos puede generar inhabilitaciones a tu cuenta.`,
    },
    {
      question:
        "¿Qué hago si el comprador no me quiere facilitar su documentación?",
      answer: `En caso de que no puedas registrar la documentación del comprador para terminar el proceso, no podrás entregarlo. Deberás cancelar el paquete e iniciar la devolución.`,
    },
    {
      question: "¿Qué hago si no puedo entregar un paquete?",
      answer: `<b>Intentá llamar al comprador,</b> en caso de que no puedas comunicarte, <b>esperá al menos 5 minutos</b> antes de iniciar la devolución.

      Tené en cuenta que podés entregar a cualquier persona mayor de 18 años que se encuentre en el domicilio, registrando sus datos en el sistema.
      
      <b>Si no podés realizar la entrega,</b> iniciá el proceso de devolución a través de la aplicación. `,
    },
    {
      question: "La dirección es incorrecta / no la encuentro, ¿qué hago?",
      answer: `Hacé clic en <b>No puedo entregarlo</b> y elegí la opción <b>Dirección incorrecta o inaccesible</b> e iniciá el proceso de devolución a través de la aplicación.`,
    },
    {
      question: " ¿Cómo hago una devolución?",
      answer: `<b>Al finalizar el viaje,</b> los paquetes que no pudiste entregar deberás llevarlos al mismo punto de retiro: \n
      *123*
      Recordá que el punto debe escanear los códigos de los paquetes que devolviste para finalizar el proceso.`,
      numberedAnswers: [
        `Ingresá en <b>Viajes</b> y hacé clic en <b>Paquetes a devolver.</b>`,
        `Una vez que se abra el viaje, hacé clic en <b>Llegué al punto.</b>`,
        `<b>Escaneá</b> los códigos de los paquetes que vas a devolver. En caso de que sea necesario, ingresalos manualmente. Hacé clic en <b>Devolver</b> y ¡listo!`,
      ],
    },
    {
      question:
        "¿Qué hago si el punto me pide un código para devolver el paquete?",
      answer: `Recordale a la persona que debe escanear o ingresar manualmente los códigos que <b>están en los paquetes.</b> El que usaste para retirarlos (PKR-) es solo un identificador del viaje, no puede ser usado para devolución.`,
    },
    {
      question:
        "¿Qué hago si el punto está cerrado cuando quiero hacer una devolución, me falta un paquete, me robaron o tuve un accidente?",
      answer: `Comunicate con nuestro equipo de soporte al @@whatsapp@@.`,
      links: [
        {
          name: "@@whatsapp@@",
          label: "WhatsApp",
          href: "{{whatsAppLink}}",
        },
      ],
    },
  ],
});

i18n.addResources("es", "Deliver", {
  title: "Entrega",
  questions: [
    {
      question: "¿Cómo entrego un paquete?",
      answer: `Al salir del punto, verás el listado de destinos para llevar los paquetes. Los mismos están ordenados por cercanía.\n
      *list*
      ¡Listo! Ya puedes continuar con tu viaje.`,
      answers: [
        `Selecciona el destino por el que quieras comenzar tu recorrido. Recuerda que el primero de la lista es el recomendado.`,
        `Una vez que te encuentres en el destino, haz clic en <b>Llegué al domicilio,</b> puedes llamar a la persona en caso que lo necesites.`,
        `Haz clic en <b>Validar entrega.</b> Completa los datos de quién recibe y la forma de validar que te indique la aplicación, puede ser foto, firma y/o escaneo del paquete. `,
        `Haz clic en <b>Entregar paquete.</b>`,
      ],
    },
    {
      question: "¿Cómo valido el documento de quien recibe?",
      answer: `La validación es automática, el sistema lo realiza con el documento que cargas en la aplicación. Recuerda que el ingreso de datos falsos puede generar inhabilitaciones a tu cuenta.`,
    },
    {
      question:
        "¿Qué hago si el comprador no me quiere facilitar su documentación?",
      answer: `En caso de que no puedas registrar la documentación del comprador para terminar el proceso, no puedes entregarlo. Deberás cancelar el paquete e iniciar la devolución.`,
    },
    {
      question: "¿Qué hago si no puedo entregar un paquete?",
      answer: `<b>Intenta llamar al comprador,</b> en caso de que no puedas comunicarte, <b>espera al menos 5 minutos</b> antes de iniciar la devolución.

      Ten presente que puedes entregar a cualquier persona mayor de 18 años que se encuentre en el domicilio, registrando sus datos en el sistema.
      
      <b>Si no puedes realizar la entrega,</b> inicia el proceso de devolución a través de la aplicación.`,
    },
    {
      question: "La dirección es incorrecta / no la encuentro, ¿qué hago?",
      answer: `Haz clic en <b>No puedo entregarlo</b> y elige la opción <b>Dirección incorrecta o inaccesible</b> e inicia el proceso de devolución a través de la aplicación.`,
    },
    {
      question: "¿Cómo hago una devolución?",
      answer: `<b>Al finalizar el viaje,</b> los paquetes que no pudiste entregar deberás llevarlos al mismo punto de retiro:\n
      *123*
      Recuerda que el punto debe escanear los códigos de los paquetes que devolviste para finalizar el proceso.`,
      numberedAnswers: [
        `Ingresa en <b>Viajes</b> y haz clic en <b>Paquetes a devolver.</b>`,
        `Una vez que se abra el viaje, haz clic en <b>Llegué al punto.</b>`,
        `<b>Escanea</b> los códigos de los paquetes que vas a devolver. En caso de que sea necesario, ingrésalos manualmente. Haz clic en <b>Devolver</b> y ¡listo!`,
      ],
    },
    {
      question:
        "¿Qué hago si el punto me pide un código para devolver el paquete?",
      answer: `Recuérdale a la persona que debe escanear o ingresar manualmente los códigos que <b>están en los paquetes.</b> El que usaste para retirarlos (PKR-) es solo un identificador del viaje, no puede ser usado para devolución.`,
    },
    {
      question:
        "¿Qué hago si el punto está cerrado cuando quiero hacer una devolución, me falta un paquete, me robaron o tuve un accidente?",
      answer: `Comunícate con nuestro equipo de soporte al @@whatsapp@@.`,
      links: [
        {
          name: "@@whatsapp@@",
          label: "WhatsApp",
          href: "{{whatsAppLink}}",
        },
      ],
    },
  ],
});

i18n.addResources("es_CO", "Deliver", {
  title: "Entrega",
  questions: [
    {
      question: "¿Qué hago antes de entregar un paquete?",
      answer: `<b>Una vez que llegues al destino,</b> ingresa al paquete que vas a entregar.
      \nHaz clic en <b>Llegué al domicilio y el sistema te indicará qué hacer en cada caso.</b>
      \n<b>Paquete con código de barras:</b> antes de entregarlo, deberás escanearlo o ingresar manualmente y tomar una foto o pedir firma de la persona que recibe el paquete.
      \n<b>Paquete sin código de barras:</b> toma una foto o pide una firma de la persona que recibe el paquete.
      \n¡Listo! Ya entregaste el paquete.`,
    },
    {
      question: "¿Qué hago si no puedo entregar un paquete?",
      answer: `<b>Intenta llamar al comprador,</b> en caso de que no puedas comunicarte, <b>espera al menos 5 minutos</b> antes de iniciar la devolución.

      Ten presente que puedes entregar el paquete a un tercero registrando sus datos en la app.
      
      <b>Si no puedes realizar la entrega,</b> inicia el proceso de devolución a través de la app.`,
    },
    {
      question: "La dirección es incorrecta / no la encuentro, ¿qué hago?",
      answer: `Haz clic en <b>Ir a soporte</b> para recibir ayuda y saber cómo continuar con tu operación.`,
    },
    {
      question: "¿Cómo hago una devolución?",
      answer: `<b>Si no puedes entregar el paquete,</b> al final del viaje acércate al punto de donde lo retiraste:\n
      *123*
      <b>En caso de que tengas algún inconveniente, haz clic en No puedo devolverlo y te comunicaremos con soporte.</b>`,
      numberedAnswers: [
        `Ingresa en <b>Viajes</b> y haz clic en <b>Paquetes a devolver.</b>`,
        `Una vez que se abra el viaje, haz clic en <b>Llegué al punto.</b>`,
        `<b>Informa</b> los códigos de los paquetes que vas a devolver a la persona del punto. En caso de que sea necesario, escanéalos o ingrésalos manualmente. Haz clic en <b>Devolver</b> y ¡listo!`,
      ],
    },
  ],
});

i18n.addResources("es_AR", "Earnings", {
  title: "Facturación",
  questions: [
    {
      question: "¿Qué encuentro en la sección Facturación?",
      answer: `En esta sección vas a encontrar dos subsecciones, en las cuales podrás controlar tus <b>Ganancias</b> y cargar tus <b>Facturas</b> de pago.`,
    },
    {
      question: "¿Qué necesito para facturar y cobrar?",
      answer: `Estar registrado en ARCA (ex AFIP) como monotributista para que puedas generar facturas y una cuenta bancaria a tu nombre. Si aún no tenés el monotributo, podés registrarte en la aplicación y operar por una semana.`,
    },
    {
      question: "Ya operé una semana, ¿cómo completo mi documentación?",
      answer: `Ingresá en @@fee@@ y completá la documentación solicitada para recibir tus pagos.`,
      links: [
        {
          name: "@@fee@@",
          label: "este formulario",
          href: "https://docs.google.com/forms/d/e/1FAIpQLSd0R4cqpHY3xjmZqUdKt3-5v5pj5p9Aq3hh7wq30thWN49TCA/viewform",
        },
      ],
    },
    {
      question: "¿Qué datos necesito para hacer la factura?",
      answer: `Los datos que necesitás son:\n
      *list*`,
      answers: [
        `<b>Fecha de la factura:</b> El día que generás la factura.`,
        `<b>Razón Social:</b> PICKIT ARGENTINA S.A.`,
        `<b>CUIT:</b> 30-71516262-4.`,
        `<b>Condición frente al IVA:</b> Responsable inscripto.`,
        `<b>Actividad principal:</b> Servicios de gestión y logística para el transporte de mercaderías.`,
        `<b>Domicilio fiscal:</b> Juramento 1775, piso 10.`,
        `<b>Código postal:</b> 1428 - CABA.`,
      ],
    },
    {
      question: "¿Cuándo y dónde cargo la factura?",
      answer: `Los días <b>sábados se habilitará en la sección Facturación el espacio para que cargues tu factura.</b> Asegurate de que los datos y el monto sean exactamente iguales a los que te indica la aplicación para evitar rechazos.   
      Tenés tiempo hasta el lunes a las 13 hs, luego de ese horario, si la documentación enviada es correcta será procesada y pagada la semana siguiente.`,
    },
    {
      question: "Cargué mi factura, ¿cómo le doy seguimiento?",
      answer: `Dentro de <b>Facturas</b>, podrás visualizar y descargar las de los últimos dos meses. Las mismas pueden estar: <b>en aprobación, aprobada, rechazada, en validación, pagada o pendiente.</b>\n
      <b>En aprobación:</b> enviaste la factura, estamos en proceso de revisión, si lo necesitás podés reemplazarla.\n
      <b>Aprobada:</b> ya revisamos tu factura y te la abonaremos en breve. Los pagos se realizan en el transcurso de los días viernes y pueden demorar hasta 72 hs en impactar en tu cuenta.\n
      <b>Rechazada:</b> la factura que cargaste tiene un error en alguno de estos campos: <b>fecha de emisión, formato del archivo, monto, CUIT de pickit, CUIT del titular, tipo de documento o condición frente al IVA.</b> Deberás volver a hacerla y cargarla nuevamente.\n
      <b>En validación:</b> Encontramos irregularidades en la factura cargada, nuestro equipo estará realizando la revisión del caso a la brevedad y te contactaremos de ser necesario.\n
      <b>Pagada:</b> la factura ya fue abonada.\n
      Cuando se encuentre <b>Pendiente,</b> ya recibiste la preliquidación y está disponible para que cargues la factura. Si tenés alguna de más de dos meses, enviala a @@fee@@ junto con el periodo correspondiente.`,
      links: [
        {
          name: "@@fee@@",
          label: "ayuda@pickers.tech",
          href: "mailto:ayuda@pickers.tech",
        },
      ],
    },
    {
      question: "¿Cómo se calculan mis Ganancias?",
      answer: `La semana de facturación inicia el sábado y finaliza el viernes. Al completar un viaje, podrás ver las ganancias en el momento. Al día siguiente, en caso de tenerlos, se mostrarán los premios diarios y el asegurado. El sábado, tendrás los premios semanales y la ganancia total para facturar.\n
      Consultá: @@fee@@`,
      links: [
        {
          name: "@@fee@@",
          label: "Tarifas y premios ",
          href: "https://linktr.ee/TarifasARpickers",
        },
      ],
    },
    {
      question: "¿Cómo saber que me pagaron?",
      answer: `Recibirás una notificación a través de la aplicación y un email cuando se realice el pago en la cuenta que informaste. Recordá que los pagos se realizan en el transcurso de los días viernes y pueden demorar hasta 72 hs en impactar en tu cuenta. \n
      Además, en la subsección <b>Facturas</b>, podrás verla en estado <b>Pagada.</b>`,
    },
    {
      question: "¿Qué es el bono por lluvia?",
      answer: `Es una ganancia que recibirás en el caso de que llueva durante tu turno. Recordá que debés comunicarte con soporte para dar aviso que está lloviendo en tu zona. Al final de la semana lo verás reflejado en tus <b>Ganancias.</b>`,
    },
    {
      question: "¿Qué es el asegurado?",
      answer: `Es un mínimo de ganancia que recibirás en el caso de que estés conectado durante el turno completo y no haya suficientes paquetes.`,
    },
  ],
});

i18n.addResources("es_AR", "RoadSafety", {
  title: "Seguridad vial",
  questions: [],
});

i18n.addResources("es_AR", "Bicycles", {
  title: "Bicicletas",
  questions: [
    {
      question: "¿Qué documentación necesito para trabajar?",
      answer: `Para andar en bici siempre conviene llevar:
      *list*`,
      answers: [
        `<b>DNI.</b>`,
        `<b>Seguro,</b> si contás con uno.`,
      ],
    },
    {
      question: "¿Qué tengo que chequear en mi bici antes de salir?",
      answer: `*list*
      Además, conviene revisar antes de cada jornada:\n
      *extralist*`,
      answers: [
        `<b>Frenos</b> delantero y trasero que respondan bien.`,
        `<b>Espejos retrovisores</b> en ambos lados.`,
        `<b>Timbre o bocina</b> que funcione.`,
        `<b>Luces:</b> blanca adelante y roja atrás.`,
        `<b>Elementos reflectantes</b> en pedales y ruedas.`,
      ],
      extraAnswers: [
        `<b>Cubiertas:</b> presión adecuada y en buen estado.`,
        `<b>Cadena:</b> lubricada y bien tensada.`,
        `<b>Asiento y manubrio:</b> bien ajustados.`,
      ],
    },
    {
      question: "¿Qué elementos de seguridad personal usar en bici?",
      answer: `*list*`,
      answers: [
        `<b>Casco homologado:</b> Es clave para tu seguridad y puede marcar la diferencia en caso de accidente.`,
        `<b>Ropa ajustada al cuerpo,</b> preferentemente de colores claros.`,
        `<b>Calzado cerrado</b> que se afirme bien a los pedales.`,
      ],
    },
  ],
});

i18n.addResources("es_AR", "Motorcycles", {
  title: "Motos",
  questions: [
    {
      question: "¿Qué documentación necesito para trabajar?",
      answer: `*list*`,
      answers: [
        `<b>DNI</b>`,
        `<b>Licencia de conducir</b> categoría A vigente`,
        `<b>Cédula del vehículo</b>`,
        `<b>Comprobante de seguro</b> obligatorio al día`,
        `<b>VTV vigente</b>`,
      ],
    },
    {
      question: "¿Qué tengo que chequear en mi moto antes de salir?",
      answer: `*list*`,
      answers: [
        `<b>Cubiertas:</b> presión correcta y en buen estado.`,
        `<b>Frenos:</b> tacto firme de la maneta, sin que llegue hasta el manubrio.`,
        `<b>Luces:</b> de freno, giro, posición y alta/baja.`,
        `<b>Cadena:</b> lubricada y con la tensión que indica el manual.`,
        `<b>Espejos:</b> los dos bien ajustados.`,
        `<b>Patente:</b> visible y en buen estado.`,
        `<b>Nivel de aceite y combustible.</b>`,
      ],
    },
    {
      question: "¿Qué elementos de seguridad personal usar en moto?",
      answer: `*list*`,
      answers: [
        `<b>Casco homologado.</b>`,
        `<b>Chaleco reflectante.</b>`,
      ],
    },
  ],
});

i18n.addResources("es_AR", "Cars", {
  title: "Autos",
  questions: [
    {
      question: "¿Qué documentación necesito para trabajar?",
      answer: `*list*`,
      answers: [
        `<b>DNI</b>`,
        `<b>Licencia de conducir</b> categoría B vigente`,
        `<b>Cédula del vehículo</b>`,
        `<b>Comprobante de seguro</b> obligatorio al día`,
        `<b>VTV vigente</b>`,
      ],
    },
    {
      question: "¿Qué tengo que chequear en mi auto antes de salir?",
      answer: `*list*`,
      answers: [
        `<b>Cinturón de seguridad:</b> que el anclaje funcione bien.`,
        `<b>Espejos:</b> interior y los dos exteriores ajustados.`,
        `<b>Soporte de celular:</b> firme, que no se caiga con el movimiento.`,
        `<b>Luces:</b> bajas, altas, giros, freno y balizas.`,
        `<b>Cubiertas:</b> incluida la de auxilio.`,
        `<b>Parabrisas y limpiaparabrisas:</b> sin fisuras y en buen estado.`,
      ],
    },
    { 
      question: "¿Qué elementos de seguridad tener en mi auto?",
      answer: `*list*`,
      answers: [
        `<b>Cinturón de seguridad</b> puesto por el conductor y todos los acompañantes.`,
        `<b>Matafuego triclase,</b> con carga vigente y fijo dentro del habitáculo.`,
        `<b>Dos balizas</b> triangulares homologadas.`,
      ],
    },
  ],
});


i18n.addResources("es_AR", "GeneralInfo", {
  title: "Información general",
  questions: [
    {
      question: "¿Cuáles son las reglas de tránsito que no puedo dejar pasar?",
      answer: `*list*`,
      answers: [
        `<b>Alcohol al volante:</b> No manejes si tomaste alcohol. Es peligroso para vos y para terceros. Revisá las normativas de tu jurisdicción.</b>`,
        `<b>Celular:</b> no se puede usar en la mano mientras manejás. Si lo necesitás para ver la ruta, tiene que estar en un soporte fijo y operarse con manos libres.</b>`,
        `<b>Velocidad:</b> respetá los máximos según la zona.</b>`,
      ],
    },
    {
      question: "¿Qué hago si tengo un accidente?",
      answer: `Lo primero y más importante: llamá al <b>911.</b> Si hay personas heridas, no las muevas y esperá a los servicios de emergencia.`,
    },
    {
      question: "¿Dónde puedo leer la normativa sobre seguridad vial?",
      answer: `Toda la información oficial y actualizada está en los sitios del Estado:
      *list*`,
      answers: [
        `<b>Ley Nacional de Tránsito y Seguridad Vial</b> (Ley 24.449): @@infoleg@@`,
        `<b>Ley 26.363</b> - Agencia Nacional de Seguridad Vial: @@ansv@@`,
        `<b>Agencia Nacional de Seguridad Vial</b> (ANSV): @@ansvlink@@`,
        `<b>Curso de Educación Vial gratuito de la ANSV:</b> @@ansvcourse@@`,
      ],
      links: [
        {
          name: "@@infoleg@@",
          label: "Ver texto en Infoleg",
          href: "https://servicios.infoleg.gob.ar/infolegInternet/anexos/0-4999/818/texact.htm",
        },
        {
          name: "@@ansv@@",
          label: "Ver texto",
          href: "https://www.argentina.gob.ar/normativa/nacional/140098/texto",
        },
        {
          name: "@@ansvlink@@",
          label: "argentina.gob.ar/seguridadvial",
          href: "https://www.argentina.gob.ar/seguridadvial",
        },
        {
          name: "@@ansvcourse@@",
          label: "curso.seguridadvial.gob.ar",
          href: "https://curso.seguridadvial.gob.ar/ansv/",
        },
      ],
    },
  ],
});

i18n.addResources("es_CO", "Earnings", {
  title: "Facturación",
  questions: [
    {
      question: "¿Qué encuentro en la sección Facturación?",
      answer: `En esta sección vas a encontrar dos subsecciones, en las cuales puedes controlar tus <b>Ganancias</b> y firmar tus notas de cobro en <b>Facturas</b>.`,
    },
    {
      question: "¿Qué necesito para la nota de cobro?",
      answer: `Es necesario que tengas el NIT activo, además de cargar y registrar el RUT en este @@fee@@.`,
      links: [
        {
          name: "@@fee@@",
          label: "formulario",
          href: "https://forms.gle/M6xxDfhR5ZAnWaqY9",
        },
      ],
    },
    {
      question: "¿Cuándo y dónde confirmo la nota de cobro?",
      answer: `En Facturas, visualizarás la preliquidación pendiente para la nota de cobro. Deberás hacer clic, verificar la información y luego firmar para validarla.`,
    },
    {
      question: "Confirmé mi nota de cobro, ¿cómo le doy seguimiento?",
      answer: `Dentro de <b>Facturas</b>, puedes visualizar y descargar las de los últimos dos meses.\n
      Las mismas pueden estar: <b>en aprobación, aprobada, pagada, pendiente y rechazada.</b>\n
      <b>En aprobación:</b> enviaste nota de cobro y está en proceso de revisión.\n
      <b>Aprobada:</b> ya revisamos tu nota de cobro y te la abonaremos en breve. Los pagos se realizan en el transcurso de los días viernes y pueden demorar hasta 72 hs en impactar en tu cuenta.\n
      <b>Rechazada:</b> la nota de cobro que confirmaste tiene un error.\n
      <b>Pagada:</b> la nota de cobro ya fue abonada.\n
      Cuando se encuentre <b>Pendiente</b>, ya recibiste la preliquidación y tienes que confirmar la nota de cobro.`,
      links: [
        {
          name: "@@fee@@",
          label: "ayuda@pickers.tech",
          href: "mailto:ayuda@pickers.tech",
        },
      ],
    },
    {
      question: "¿Cómo se calculan mis Ganancias?",
      answer: `La semana de facturación inicia el sábado y finaliza el viernes. Al completar un viaje, puedes ver las ganancias en el momento. Al día siguiente, en caso de tenerlos, se mostrarán los premios diarios.
      El sábado, tendrás los premios semanales y la ganancia total para facturar.\n
      Consulta: @@fee@@`,
      links: [
        {
          name: "@@fee@@",
          label: "Tarifas y premios",
          href: "https://linktr.ee/TarifasCOpickers",
        },
      ],
    },
    {
      question: "¿Qué es el bono por lluvia?",
      answer: `Es una ganancia que recibirás en el caso de que llueva durante tu turno. Recuerda que debes comunicarte con soporte para dar aviso que está lloviendo en tu zona.`,
    },
    {
      question: "¿Cómo saber que me pagaron?",
      answer: `Recibirás una notificación a través de la aplicación y un email cuando se realice el pago en la cuenta que informaste. Recuerda que los pagos se realizan en el transcurso de los días viernes y pueden demorar hasta 72 hs en impactar en tu cuenta.
      Además, en la subsección <b>Facturas</b>, puedes verla en estado <b>Pagada</b>.`,
    },
  ],
});

i18n.addResources("es_MX", "Earnings", {
  title: "Facturación",
  questions: [
    {
      question: "¿Qué encuentro en la sección Facturación?",
      answer: `En esta sección vas a encontrar dos subsecciones, en las cuales puedes controlar tus <b>Ganancias</b> y cargar tus <b>Facturas</b> de pago.`,
    },
    {
      question: "¿Qué necesito para facturar y cobrar?",
      answer: `Tener el CURP, una cuenta bancaria a tu nombre, RFC y sellos digitales o Certificado de sellos digitales (CSD) que se componen de dos archivos y una contraseña que el SAT proporciona para cumplir con las obligaciones fiscales en México. Si aún no los tienes, puedes registrarte en la aplicación y operar por una semana.`,
    },
    {
      question: "Ya operé una semana, ¿cómo completo mi documentación?",
      answer: `Ingresa en @@fee@@ y completa la documentación solicitada para recibir tus pagos.`,
      links: [
        {
          name: "@@fee@@",
          label: "este formulario",
          href: "https://docs.google.com/forms/d/e/1FAIpQLSd0R4cqpHY3xjmZqUdKt3-5v5pj5p9Aq3hh7wq30thWN49TCA/viewform",
        },
      ],
    },
    {
      question: "¿Qué datos necesito para hacer la factura?",
      answer: `Los datos que necesitas son:\n
      *list*
      Recuerda, al momento de facturar:\n
      *extralist*`,
      answers: [
        `<b>Tipo documento:</b> “Serie A”.`,
        `<b>Fecha de la factura:</b> El día que generas la factura.`,
        `<b>Razón Social:</b> PICKIT MÉXICO.`,
        `<b>RFC:</b> PME190521ET6.`,
        `<b>Actividad principal:</b> Servicio de mensajería.`,
        `<b>Domicilio fiscal:</b> Calle Asistencia pública, Calle 28, Norte 3 Santa Cruz Aviación, Venusiano Carranza.`,
        `<b>Código postal:</b> 15540.`,
      ],
      extraAnswers: [
        `<b>Razón social:</b> En SAT figura como “Pickit México”.`,
        `<b>Monto de facturación:</b> Debe ser el importe de la “Ganancia final” + impuestos trasladados (16 % IVA).`,
        `<b>No marcar impuestos derivados.</b>`,
        `<b>Clave del producto y/o servicio:</b> 78102203.`,
        `<b>Descripción recomendada:</b> Servicio de entrega y recolección de mercancía.`,
      ],
    },
    {
      question: "¿Cuándo y dónde cargo la factura?",
      answer: `Los días <b>sábados se habilitará en la sección Facturación el espacio para que cargues tu factura.</b>\nAsegúrate de que los datos y el monto sean exactamente iguales a los que te indica la aplicación para evitar rechazos.\n
      Tienes tiempo hasta el lunes a las 13 hs, luego de ese horario, si la documentación enviada es correcta será procesada y pagada la semana siguiente.`,
    },
    {
      question: "Cargué mi factura, ¿cómo le doy seguimiento?",
      answer: `Dentro de <b>Facturas</b>, puedes visualizar y descargar las de los últimos dos meses. Las mismas pueden estar: <b>en aprobación, aprobada, rechazada, pagada o pendiente.</b>\n
      <b>En aprobación:</b> enviaste la factura, estamos en proceso de revisión, si lo necesitas puedes reemplazarla.\n
      <b>Aprobada:</b> ya revisamos tu factura y te la abonaremos en breve. Los pagos se realizan en el transcurso de los días viernes y pueden demorar hasta 72 hs en impactar en tu cuenta.\n
      <b>Rechazada:</b> la factura que cargaste tiene un error en alguno de estos campos: <b>impuestos trasladados IVA, impuestos retenidos ISR, fecha de emisión, formato del archivo, subtotal del monto, RFC de pickit, RFC emisor, razón social, folio fiscal o tipo de documento</b>. Deberás volver a hacerla y cargarla nuevamente.\n
      <b>Pagada:</b> la factura ya fue abonada.\n
      Cuando se encuentre <b>Pendiente</b>, ya recibiste la preliquidación y está disponible para que cargues la factura. Si tienes alguna de más de dos meses, envíala a @@fee@@ junto con el período correspondiente.`,
      links: [
        {
          name: "@@fee@@",
          label: "ayuda@pickers.tech",
          href: "mailto:ayuda@pickers.tech",
        },
      ],
    },
    {
      question: "¿Cómo se calculan mis Ganancias?",
      answer: `La semana de facturación inicia el sábado y finaliza el viernes. Al completar un viaje, puedes ver las ganancias en el momento. El sábado tendrás la ganancia total para facturar.\n
      Consulta: @@fee@@`,
      links: [
        {
          name: "@@fee@@",
          label: "Tarifas y premios",
          href: "https://linktr.ee/tarifasmxpickers",
        },
      ],
    },
    {
      question: "¿Cómo saber que me pagaron?",
      answer: `Recibirás una notificación a través de la aplicación y un email cuando se realice el pago en la cuenta que informaste. Recuerda que los pagos se realizan en el transcurso de los días viernes y pueden demorar hasta 72 hs en impactar en tu cuenta.\n
      Además, en la subsección <b>Facturas</b>, puedes verla en estado <b>Pagada</b>.`,
    },
    {
      question: "¿Qué es el bono por lluvia?",
      answer: `Es una ganancia que recibirás en el caso de que llueva durante tu turno. Recuerda que debes comunicarte con soporte para dar aviso que está lloviendo en tu zona. Al final de la semana lo verás reflejado en tus <b>Ganancias.</b>`,
    },
  ],
});

i18n.addResources("es_CL", "Account", {
  title: "Cuenta",
  questions: [
    {
      question: "¿Dónde opera pickers?",
      answer: "pickers opera en Argentina, México y Chile.",
    },
    {
      question: "¿Cuáles son los días y horarios de conexión?",
      answer:
        "Nuestra operación funciona de lunes a viernes (días hábiles) de 10 a 18 hs.",
    },
    {
      question: "¿Qué necesito para ser un picker?",
      answer: `Para ser picker necesitas:\n
      *list*
      Los paquetes que vas a transportar son pequeños (no son comidas), por eso puedes retirar más de uno en los puntos de retiro. Además, no necesitas dinero porque ya están pagos.\n      
      <b>Documentación:</b>\n
      *extralist*
      ¿Necesitas ayuda? Ingresa a @@tutorial@@`,
      answers: [
        `Ser mayor de edad.`,
        `Celular con sistema operativo Android.`,
        `Vehículo (moto, bicicleta, auto o camioneta estilo cargo o furgón) y la documentación correspondiente (licencia de conducir, permiso de circulación, seguro del vehículo SOAP, y hoja de vida). En caso de que utilices moto deberás tener casco.`,
        `Mochila / caja para transportar los paquetes.`,
        `Cuenta bancaria a tu nombre (no billetera virtual).`,
      ],
      extraAnswers: [
        `RUN (Cédula de identidad).`,
        `Inscripción en el SII con RUT activo en primera categoría para emitir boletas.`,
        `Certificado de antecedentes.`,
        `Certificado de cuenta bancaria.`,
      ],
      links: [
        {
          name: "@@tutorial@@",
          label: "este tutorial.",
          href: "https://docs.google.com/presentation/d/e/2PACX-1vTGPOIgttWxdG0cXQ0ehh2H-W6DwFN4sWcq44da1g8D6OVkBAoX530iF-Fqq5fCLXecfHPd20-WI2Aw/pub?start=false&loop=false&delayms=3000&slide=id.g1efc9231ee2_0_0",
        },
      ],
    },
    {
      question: "¿Cuándo puedo empezar a operar?",
      answer: `Puedes registrarte en la aplicación y, en caso de que no cuentes con toda la documentación, operar una semana con nosotros. Es importante que la completes para que podamos gestionar tus pagos.
      \nEn caso de que la zona que quieras operar esté con capacidad máxima de repartidores, tu cuenta estará en lista de espera.`,
    },
    {
      question: "¿Cómo actualizo mis datos personales? ",
      answer: `Ingresa a este @@form@@ para actualizar tus datos o los del vehículo. Los tiempos de gestión son:\n
      <b>3 días hábiles:</b>
      *list*
      <b>7 días hábiles:</b>
      *extralist*
      En caso de que los cambios que solicitaste no se realicen en el tiempo pactado, comunícate con @@email@@ para iniciar un reclamo. `,
      answers: [
        `Nombre y apellido.`,
        `Número de teléfono. `,
        `Cuenta bancaria.`,
      ],
      extraAnswers: [`Cédula de identidad.`, `RUT.`, `Email.`],
      links: [
        {
          name: "@@form@@",
          label: "formulario",
          href: "https://docs.google.com/forms/d/e/1FAIpQLSd0R4cqpHY3xjmZqUdKt3-5v5pj5p9Aq3hh7wq30thWN49TCA/viewform",
        },
        {
          name: "@@email@@",
          label: "ayuda@pickers.tech",
          href: "mailto:ayuda@pickers.tech",
        },
      ],
    },
    {
      question: "¿Qué pasa si no me presento a un turno?",
      answer: `En caso de que no te presentes a un turno, y no lo hayas cancelado con anterioridad, se cancelarán todos los turnos de la semana y podrán ser tomados por otros pickers.

        <b>Si las ausencias se repiten, tu cuenta será inhabilitada y no puedes operar hasta que nos comuniquemos contigo.</b>
        `,
    },
    {
      question: "¿Por qué inhabilitaron mi cuenta?",
      answer: `Las inhabilitaciones se realizan cuando no cumples con @@conditions@@, otros motivos pueden ser:\n
      *list*`,
      answers: [
        `Faltas reiteradas a los turnos reservados.`,
        `Cancelaciones de turnos con menos de 24 horas de anticipación.`,
        `Mala evidencia de entrega o poco tiempo de espera por comprador.`,
        `No lograr el 90% de eficiencia en las entregas.`,
        `Mensajes o lenguaje abusivo que agreda o insulte al personal de los puntos, operaciones, soporte y compradores.`,
        `Reiterada pérdida o extravío de paquetes.`,
        `Datos falsos para recibir o entregar paquetes.`,
      ],
      links: [
        {
          name: "@@conditions@@",
          label: "nuestros términos y condiciones",
          href: "https://docs.google.com/document/d/e/2PACX-1vQKFi-L04SablMHC5bP5yDwihJGn_eRAaupsqi5x4KN6iWA_zxOtrl5Yo7K4C_pBHKPbCbwzMLp2H1v/pub",
        },
      ],
    },
    {
      question: "Buenas prácticas para el uso de tu cuenta",
      answer: `Te compartimos algunos consejos para tu operación:\n
      *list*`,
      answers: [
        `No compartas, alquiles, o prestes tu cuenta a terceros.`,
        `No utilices aplicaciones que alteren tu ubicación.`,
        `Realiza los pasos para el retiro, entrega y devolución tal como aparecen en la aplicación.`,
        `Acepta la responsabilidad del viaje asignado, cumpliendo con los tiempos y acercándote al punto de retiro inmediatamente para evitar inconvenientes.`,
        `Verifica que los puntos registren las devoluciones.`,
      ],
    },
    {
      question: "Actualización de la aplicación",
      answer: `En pickers siempre estamos realizando mejoras, por eso te recomendamos que mantengas <b>actualizada la aplicación</b> y revises regularmente si tienes la última versión de la @@link@@.`,
      links: [
        {
          name: "@@link@@",
          label: "Play Store",
          href: "https://play.google.com/store/apps/details?id=com.pickit.pickers&hl=es_AR",
        },
      ],
    },
    {
      question: "¿Qué hago si tengo un problema durante el recorrido?",
      answer: `Comunícate con nuestro equipo de soporte al @@whatsapp@@.`,
      links: [
        {
          name: "@@whatsapp@@",
          label: "WhatsApp",
          href: "{{whatsAppLink}}",
        },
      ],
    },
  ],
});

i18n.addResources("es_CL", "Slots", {
  title: "Turnos",
  questions: [
    {
      question: "¿Para qué se utilizan los turnos?",
      answer: `Con los turnos puedes elegir qué zonas, días y horarios vas a estar disponible para operar con nosotros. Para conocerlos ingresa en la sección <b>Turnos</b> dentro de la aplicación.`,
    },
    {
      question: "¿Cuándo se habilitan los turnos?",
      answer: `<b>Los turnos se habilitan los jueves a partir de las 18:00 hs</b>, puedes reservar los de toda la semana dentro de la aplicación en la sección <b>Turnos.</b> Revisa todos los días la sección, ya que pueden liberarse algunos durante el día.`,
    },
    {
      question: "¿Cómo tomo un turno?",
      answer: `Una vez dentro de la aplicación:\n
      *123*
      ¡Listo! Para verlos ingresa en Reservados dentro de <b>Turnos</b>.`,
      numberedAnswers: [
        `Ingresa en la sección de <b>Turnos.</b>`,
        `Elige las @@zones@@, días y horarios para operar. Recuerda que las zonas son las que seleccionaste al momento de tu registro.`,
        `Haz clic en Reservar.`,
      ],
      links: [
        {
          name: "@@zones@@",
          label: "zonas",
          href: "{{zonesLink}}",
        },
      ],
    },
    {
      question: "¿Cuáles son mis zonas?",
      answer:
        "Las zonas disponibles corresponden a las que elegiste en el momento del registro. Puedes tomar un turno dentro de esas opciones. Recuerda que cuando comience un turno tendrás que estar en el área para poder operar.",
    },
    {
      question: " ¿Qué hago si quiero tomar más zonas?",
      answer: `Comunícate con nuestro equipo de soporte al @@whatsapp@@.\n
        <b>Recuerda que no puedes tomar turnos en más de una zona en simultáneo.</b>`,
      links: [
        {
          name: "@@whatsapp@@",
          label: "WhatsApp",
          href: "{{whatsAppLink}}",
        },
      ],
    },
    {
      question: "¿Cómo iniciar un turno (check-in)? ",
      answer: `Una vez dentro de la aplicación:\n
      *123*
      ¡Listo! Ya puedes iniciar un viaje.`,
      numberedAnswers: [
        `Dirígete a tu @@zone@@ Una vez allí, <b>ingresa</b> a la sección de <b>Turnos.</b>`,
        `Haz clic en <b>Reservados.</b>`,
        `Selecciona Iniciar turno (puedes ver el botón cuando el turno esté cercano al horario de inicio).`,
      ],
      links: [
        {
          name: "@@zone@@",
          label: "zona de reparto",
          href: "{{zonesLink}}",
        },
      ],
    },
    {
      question: "¿Cuánto tiempo tengo para hacer el check-in?",
      answer: `Puedes iniciar tu turno desde 10 minutos antes hasta 15 minutos después.\n 
      En caso de que <b>no se realice el check-in perderás todos los turnos reservados en la semana.</b>`,
    },
    {
      question: "¿Puedo asignarme un turno que ya comenzó?",
      answer: `En caso de que <b>el turno tenga capacidad disponible</b> puedes asignártelo sin necesidad de hacer el check-in.`,
    },
    {
      question: "¿Cómo cancelo un turno?",
      answer: `Una vez dentro de la aplicación:\n
      *123*
      ¡Listo! Ya cancelaste el turno.`,
      numberedAnswers: [
        `Ingresa a <b>Reservados</b> dentro de la sección de <b>Turnos</b>.`,
        `Selecciona el turno que quieres cancelar.`,
        `Haz clic en el cesto.`,
      ],
    },
  ],
});

i18n.addResources("es_CL", "Trips", {
  title: "Viajes",
  questions: [
    {
      question: "¿Qué es un viaje?",
      answer: `Un viaje es un conjunto de paquetes que comparten el mismo punto de origen y región, esto te permite ahorrar tiempo en tus entregas.\n
      La cantidad de paquetes dentro de un viaje pueden variar entre 15 o más.`,
    },
    {
      question: "¿Qué es un viaje PRO?",
      answer: `<b>Es un viaje con mayor ganancia</b> donde entregas varios paquetes iguales en un mismo destino. Por ejemplo: si un cliente compró 5 productos iguales, verás la etiqueta <b>PRO</b> en tu listado (recuerda que el listado mostrará la cantidad de paradas pendientes en tu viaje).\n
      Para completarlo:
      *list*
      Al finalizar la semana recibirás en tu balance semanal un extra por cada paquete PRO. \n
      Tip: Cada parada tiene un máximo de 10 paquetes.`,
      answers: [
        `Escanea cada uno de los paquetes por separado.`,
        `Solo cargarás los datos de quien recibe una vez.`,
      ],
    },
    {
      question: "¿Cómo me asigno un viaje?",
      answer: `Una vez que iniciaste tu turno: \n
      *123*`,
      numberedAnswers: [
        `Ingresa en el menú.`,
        `Haz clic en <b>Viajes.</b>`,
        `<b>Inicia</b> un viaje y <b>comienza</b> a operar.`,
      ],
    },
  ],
});

i18n.addResources("es_CL", "PickUp", {
  title: "Retiro",
  questions: [
    {
      question: "¿De dónde retiro los paquetes?",
      answer: `De los locales que forman parte de nuestra red y se los conoce como puntos pickit. 
      
      Conoce cuáles están en tu zona: @@country@@`,
      links: [
        {
          name: "@@country@@",
          label: "{{country}}",
          href: "{{zonesLink}}",
        },
      ],
    },
    {
      question: "Llegué al punto, ¿qué hago?",
      answer: `*123*`,
      numberedAnswers: [
        `Haz clic en <b>Llegué al punto.</b>`,
        `Presenta el <b>código de barras desde la aplicación.</b> En caso de que el punto no tenga lector, infórmale el número de retiro que encontrás debajo del código (PKR-). 
        Puedes ver el número de cada paquete, haciendo clic en la lupa que está debajo del código de barras.`,
        `Escanea <b>todos los paquetes</b> que te entrega el punto, en caso de que tengas inconveniente con alguno, puedes ingresarlo manualmente.`,
      ],
    },
    {
      question: "No puedo retirar el paquete o varios paquetes, ¿qué hago?",
      answer: `En caso de que los paquetes no se encuentren en condiciones, el punto esté cerrado o con algún problema, en la aplicación haz clic en <b>No puedo retirarlos</b> e indica el motivo general. 

      Si tienes problemas con un paquete, utiliza la opción del cesto para eliminarlo del viaje. 
      
      En caso de no encontrar el motivo dentro de la aplicación, haz clic en <b>Ir a soporte.</b> 
      `,
    },
    {
      question: "Ya tengo los paquetes, ¿qué hago?",
      answer: `<b>Una vez que retires los paquetes,</b> puedes tener dos tipos: 

      <b>Paquetes con código de barras:</b> Hay que escanearlos, y si no puedes hacerlo, ingrésalo manualmente. 
      
      <b>Paquetes sin código de barras:</b> Solo confirmar que los tienes, no hay que escanearlos. 
            
      En caso de que no puedas retirarlos, haz clic en el cesto para eliminarlo de la lista.
      `,
    },
    {
      question: "¿Qué hago si se cancela un viaje?",
      answer: `En caso de que se cancele un viaje te avisaremos a través de la aplicación y puedes asignarte otro.`,
    },
  ],
});

i18n.addResources("es_CL", "Deliver", {
  title: "Entrega",
  questions: [
    {
      question: "¿Cómo entrego un paquete?",
      answer: `Al salir del punto, verás el listado de destinos para llevar los paquetes. Los mismos están ordenados por cercanía.
      *123*
      ¡Listo! Ya puedes continuar con tu viaje.`,
      numberedAnswers: [
        `Selecciona el destino por el que quieras comenzar tu recorrido. Recuerda que el primero de la lista es el recomendado.`,
        `Una vez que te encuentres en el destino, haz clic en <b>Llegué al domicilio,</b> puedes llamar a la persona en caso que lo necesites.`,
        `Haz clic en <b>Validar entrega.</b> Completa los datos de quién recibe y escanea el código de barras y/o tómale una foto a la persona con su paquete.`,
        `Haz clic en <b>Entregar paquete.</b>`,
      ],
    },
    {
      question: "¿Cómo valido el documento de quien recibe?",
      answer: `La validación es automática, el sistema lo realiza con el documento que cargas en la aplicación. Recuerda que el ingreso de datos falsos puede generar inhabilitaciones a tu cuenta.`,
    },
    {
      question:
        "¿Qué hago si el comprador no me quiere facilitar su documentación?",
      answer: `En caso de que no puedas registrar la documentación del comprador para terminar el proceso, no puedes entregarlo. Deberás cancelar el paquete e iniciar la devolución.`,
    },
    {
      question: "¿Qué hago si no puedo entregar un paquete?",
      answer: `<b>Intenta llamar al comprador,</b> en caso de que no puedas comunicarte, <b>espera al menos 5 minutos</b> antes de iniciar la devolución.

      Ten presente que puedes entregar a cualquier persona mayor de 18 años que se encuentre en el domicilio, registrando sus datos en el sistema.

      <b>Si no puedes realizar la entrega,</b> inicia el proceso de devolución a través de la aplicación.`,
    },
    {
      question: "La dirección es incorrecta / no la encuentro, ¿qué hago?",
      answer: `Haz clic en <b>No puedo entregarlo</b> y elige la opción <b>Dirección incorrecta o inaccesible</b> e inicia el proceso de devolución a través de la aplicación.`,
    },
    {
      question: "¿Cómo hago una devolución?",
      answer: `<b>Al finalizar el viaje,</b> los paquetes que no pudiste entregar deberás llevarlos al mismo punto de retiro:
      *123*
      Recuerda que el punto debe escanear los códigos de los paquetes que devolviste para finalizar el proceso.`,
      numberedAnswers: [
        `Ingresa en <b>Viajes</b> y haz clic en <b>Paquetes a devolver.</b>`,
        `Una vez que se abra el viaje, haz clic en <b>Llegué al punto.</b>`,
        `<b>Escanea</b> los códigos de los paquetes que vas a devolver. En caso de que sea necesario, ingrésalos manualmente. Haz clic en <b>Devolver</b> y ¡listo!`,
      ],
    },
    {
      question:
        "¿Qué hago si el punto me pide un código para devolver el paquete?",
      answer: `Recuérdale a la persona que debe escanear o ingresar manualmente los códigos que <b>están en los paquetes.</b> El que usaste para retirarlos (PKR-) es solo un identificador del viaje, no puede ser usado para devolución.`,
    },
    {
      question:
        "¿Qué hago si el punto está cerrado cuando quiero hacer una devolución, me falta un paquete, me robaron o tuve un accidente?",
      answer: `Comunícate con nuestro equipo de soporte al @@whatsapp@@.`,
      links: [
        {
          name: "@@whatsapp@@",
          label: "WhatsApp",
          href: "{{whatsAppLink}}",
        },
      ],
    },
  ],
});

i18n.addResources("es_CL", "Earnings", {
  title: "Facturación",
  questions: [
    {
      question: "¿Qué encuentro en la sección Facturación?",
      answer: `En esta sección vas a encontrar dos subsecciones, en las cuales puedes controlar tus <b>Ganancias</b> y cargar tus <b>Boletas</b> de honorarios.`,
    },
    {
      question: "¿Qué necesito para hacer una boleta y cobrar?",
      answer: `Estar inscrito en el SII (Sistema de Impuesto Interno) con el RUT activo en la primera categoría para generar boletas y tener una cuenta bancaria. Si aún no tienes esta documentación puedes registrarte en la aplicación y operar una semana.`,
    },
    {
      question: "Ya operé una semana, ¿cómo completo mi documentación?",
      answer: `Ingresa en @@fee@@ y completa la documentación solicitada para recibir tus pagos.`,
      links: [
        {
          name: "@@fee@@",
          label: "este formulario",
          href: "https://docs.google.com/forms/d/e/1FAIpQLSd0R4cqpHY3xjmZqUdKt3-5v5pj5p9Aq3hh7wq30thWN49TCA/viewform",
        },
      ],
    },
    {
      question: "¿Qué datos necesito para hacer una boleta?",
      answer: `Los datos que necesitas son:\n
      *list*`,
      answers: [
        `<b>Tipo de documento:</b> Boleta de honorarios.`,
        `<b>Nombre del emisor:</b> SOCIEDAD COMERCIAL, LOGISTICA Y TRANSPORTE PICKIT CHILE SPA.`,
        `<b>RUT del emisor:</b> 77209255-5.`,
        `<b>Actividad principal:</b> Servicio de mensajería.`,
        `<b>Domicilio fiscal:</b> Huérfanos 886 DP 724, dpto. 724, Santiago.`,
      ],
    },
    {
      question: "¿Cuándo y dónde cargo la boleta?",
      answer: `Los días <b>sábados se habilitará en la sección Facturación el espacio para que cargues tu boleta.</b> Asegúrate de que los datos y el monto sean exactamente iguales a los que te indica la aplicación para evitar rechazos. \n
      Tienes tiempo hasta el lunes a las 13 hs, luego de ese horario, si la documentación enviada es correcta será procesada y pagada la semana siguiente.`,
    },
    {
      question: "Cargué mi boleta, ¿cómo le doy seguimiento?",
      answer: `Dentro de <b>Boletas</b>, puedes visualizar y descargar las de los últimos dos meses. Las mismas pueden estar: <b>en aprobación, aprobada, rechazada, pagada o pendiente.</b>\n
      <b>En aprobación:</b> Enviaste la boleta, estamos en proceso de revisión, si lo necesitas puedes reemplazarla.\n
      <b>Aprobada:</b> Ya revisamos tu boleta y te la abonaremos en breve. Los pagos se realizan en el transcurso de los días viernes y pueden demorar hasta 72 hs en impactar en tu cuenta.\n
      <b>Rechazada:</b> La boleta que cargaste tiene un error deberás volver a hacerla y cargarla nuevamente.\n
      <b>Pagada:</b> La boleta ya fue abonada.\n
      Cuando se encuentre <b>Pendiente</b>, ya recibiste la preliquidación y está disponible para que cargues la boleta. Si tienes alguna de más de dos meses, envíala a @@fee@@ junto con el período correspondiente.`,
      links: [
        {
          name: "@@fee@@",
          label: "ayuda@pickers.tech",
          href: "mailto:ayuda@pickers.tech",
        },
      ],
    },
    {
      question: "¿Cómo se calculan mis Ganancias?",
      answer: `La semana de facturación inicia el sábado y finaliza el viernes. Al completar un viaje, puedes ver las ganancias en el momento. El sábado, tendrás los premios semanales y la ganancia total para hacer la boleta.\n
      Consulta: @@fee@@`,
      links: [
        {
          name: "@@fee@@",
          label: "Tarifas y premios",
          href: "https://linktr.ee/tarifasclpickers",
        },
      ],
    },
    {
      question: "¿Cómo saber que me pagaron?",
      answer: `Recibirás una notificación a través de la aplicación y un email cuando se realice el pago en la cuenta que informaste. Recuerda que los pagos se realizan en el transcurso de los días viernes y pueden demorar hasta 72 hs en impactar en tu cuenta. \n
      Además, en la subsección <b>Boletas</b>, puedes verla en estado <b>Pagada</b>.`,
    },
    {
      question: "¿Qué es el bono por lluvia?",
      answer: `Es una ganancia que recibirás en el caso de que llueva durante tu turno. Recuerda que debes comunicarte con soporte para dar aviso que está lloviendo en tu zona al final de la semana lo verás reflejado en tus <b>Ganancias.</b>`,
    },
  ],
});
